import { z } from "zod";

export const restaurantCreateSchema = z.object({
  code: z.string().min(1, "Code is required"),
  name: z.string().min(1, "Name is required"),
  description: z.string().optional(),
});

export const restaurantUpdateSchema = z.object({
  code: z.string().min(1, "Code is required").optional(),
  name: z.string().min(1, "Name is required").optional(),
  description: z.string().optional(),
});

export type RestaurantCreateFormData = z.infer<typeof restaurantCreateSchema>;
export type RestaurantUpdateFormData = z.infer<typeof restaurantUpdateSchema>;

export interface Restaurant {
  id: string;
  code: string;
  name: string;
  description?: string;
  tenantId?: string;
  createdBy?: string;
  createdAt: string;
  updatedAt: string;
}

export interface RestaurantResult {
  restaurants: Restaurant[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export interface RestaurantFilters {
  page?: number;
  pageSize?: number;
  search?: string;
}

export interface UpdateRestaurantPayload {
  id: string;
  restaurant: RestaurantUpdateFormData;
}
